// landIeul: constants/match/{landMatchQuestions,landMatchPattern,landResultContents}.ts をそのまま移植。
// 診断クイズの設問・回答パターン・結果コンテンツ。Question の Stimulus から参照する。

export interface Choice {
  value: string;
  text: string;
}

export interface Question {
  id: number;
  title: string;
  name: string;
  choices: Choice[];
}

export const LAND_MATCH_QUESTIONS: Question[] = [
  {
    id: 1,
    title: "Q1 土地活用の目的は何ですか？",
    name: "firstQuestion",
    choices: [
      { value: "a", text: "相続税を節税するため" },
      { value: "b", text: "固定資産税を節税するため" },
      { value: "c", text: "安定した収入を得るため" },
      { value: "d", text: "老後の資産形成のため" },
      { value: "e", text: "短期的に活用したいため" },
      { value: "f", text: "遊休地を活用したい" },
      { value: "g", text: "今建っている建物を建て替えたい" },
      { value: "h", text: "特にない" },
    ],
  },
  {
    id: 2,
    title: "Q2 持っている土地の立地として、一番近いものを教えてください",
    name: "secondQuestion",
    choices: [
      { value: "a", text: "住宅街にある土地" },
      { value: "b", text: "駅前・駅近にある土地" },
      { value: "c", text: "幹線道路沿いにある土地" },
      { value: "d", text: "郊外にある土地" },
      { value: "e", text: "駅から遠い・田舎にある土地" },
    ],
  },
  {
    id: 3,
    title: "Q3 土地の広さはどのくらいですか？",
    name: "thirdQuestion",
    choices: [
      { value: "a", text: "100坪（約330㎡）未満" },
      { value: "b", text: "100坪〜500坪（約330㎡~1,652㎡）" },
      { value: "c", text: "500坪（約1,652㎡）以上" },
    ],
  },
];

export interface Pattern {
  inputPattern: string[];
  resultPattern: number[];
}

export const LAND_MATCH_PATTERN: Pattern[] = [
  { inputPattern: ["a", "a", "a"], resultPattern: [5, 1, 4] },
  { inputPattern: ["a", "a", "b"], resultPattern: [1, 4, 2] },
  { inputPattern: ["a", "a", "c"], resultPattern: [2, 1, 4] },
  { inputPattern: ["a", "b", "a"], resultPattern: [1, 4, 5] },
  { inputPattern: ["a", "b", "b"], resultPattern: [3, 13, 4] },
  { inputPattern: ["a", "b", "c"], resultPattern: [2, 13, 11] },
  { inputPattern: ["a", "c", "a"], resultPattern: [1, 4, 5] },
  { inputPattern: ["a", "c", "b"], resultPattern: [3, 4, 5] },
  { inputPattern: ["a", "c", "c"], resultPattern: [3, 4, 5] },
  { inputPattern: ["a", "d", "a"], resultPattern: [5, 4, 1] },
  { inputPattern: ["a", "d", "b"], resultPattern: [9, 5, 1] },
  { inputPattern: ["a", "d", "c"], resultPattern: [9, 5, 1] },
  { inputPattern: ["a", "e", "a"], resultPattern: [5, 4, 1] },
  { inputPattern: ["a", "e", "b"], resultPattern: [9, 5, 4] },
  { inputPattern: ["a", "e", "c"], resultPattern: [9, 5, 4] },
  { inputPattern: ["b", "a", "a"], resultPattern: [5, 1, 4] },
  { inputPattern: ["b", "a", "b"], resultPattern: [1, 4, 2] },
  { inputPattern: ["b", "a", "c"], resultPattern: [2, 1, 4] },
  { inputPattern: ["b", "b", "a"], resultPattern: [1, 4, 5] },
  { inputPattern: ["b", "b", "b"], resultPattern: [3, 13, 4] },
  { inputPattern: ["b", "b", "c"], resultPattern: [2, 13, 1] },
  { inputPattern: ["b", "c", "a"], resultPattern: [5, 4, 1] },
  { inputPattern: ["b", "c", "b"], resultPattern: [1, 4, 5] },
  { inputPattern: ["b", "c", "c"], resultPattern: [1, 4, 5] },
  { inputPattern: ["b", "d", "a"], resultPattern: [5, 4, 1] },
  { inputPattern: ["b", "d", "b"], resultPattern: [9, 5, 1] },
  { inputPattern: ["b", "d", "c"], resultPattern: [9, 5, 1] },
  { inputPattern: ["b", "e", "a"], resultPattern: [5, 4, 1] },
  { inputPattern: ["b", "e", "b"], resultPattern: [9, 5, 4] },
  { inputPattern: ["b", "e", "c"], resultPattern: [9, 5, 4] },
  { inputPattern: ["c", "a", "a"], resultPattern: [1, 8, 6] },
  { inputPattern: ["c", "a", "b"], resultPattern: [3, 4, 8] },
  { inputPattern: ["c", "a", "c"], resultPattern: [3, 4, 8] },
  { inputPattern: ["c", "b", "a"], resultPattern: [3, 4, 6] },
  { inputPattern: ["c", "b", "b"], resultPattern: [3, 4, 13] },
  { inputPattern: ["c", "b", "c"], resultPattern: [13, 3, 10] },
  { inputPattern: ["c", "c", "a"], resultPattern: [14, 16, 7] },
  { inputPattern: ["c", "c", "b"], resultPattern: [14, 16, 7] },
  { inputPattern: ["c", "c", "c"], resultPattern: [14, 16, 7] },
  { inputPattern: ["c", "d", "a"], resultPattern: [5, 7, 14] },
  { inputPattern: ["c", "d", "b"], resultPattern: [4, 7, 14] },
  { inputPattern: ["c", "d", "c"], resultPattern: [4, 7, 14] },
  { inputPattern: ["c", "e", "a"], resultPattern: [12, 5, 7] },
  { inputPattern: ["c", "e", "b"], resultPattern: [12, 5, 7] },
  { inputPattern: ["c", "e", "c"], resultPattern: [12, 5, 7] },
  { inputPattern: ["d", "a", "a"], resultPattern: [1, 4, 8] },
  { inputPattern: ["d", "a", "b"], resultPattern: [3, 4, 8] },
  { inputPattern: ["d", "a", "c"], resultPattern: [3, 4, 8] },
  { inputPattern: ["d", "b", "a"], resultPattern: [3, 4, 11] },
  { inputPattern: ["d", "b", "b"], resultPattern: [3, 4, 11] },
  { inputPattern: ["d", "b", "c"], resultPattern: [3, 10, 11] },
  { inputPattern: ["d", "c", "a"], resultPattern: [16, 7, 9] },
  { inputPattern: ["d", "c", "b"], resultPattern: [16, 7, 9] },
  { inputPattern: ["d", "c", "c"], resultPattern: [16, 7, 9] },
  { inputPattern: ["d", "d", "a"], resultPattern: [5, 7, 9] },
  { inputPattern: ["d", "d", "b"], resultPattern: [4, 7, 9] },
  { inputPattern: ["d", "d", "c"], resultPattern: [4, 7, 9] },
  { inputPattern: ["d", "e", "a"], resultPattern: [5, 7, 12] },
  { inputPattern: ["d", "e", "b"], resultPattern: [5, 7, 12] },
  { inputPattern: ["d", "e", "c"], resultPattern: [5, 7, 12] },
  { inputPattern: ["e", "a", "a"], resultPattern: [6, 7, 15] },
  { inputPattern: ["e", "a", "b"], resultPattern: [6, 7, 15] },
  { inputPattern: ["e", "a", "c"], resultPattern: [6, 7, 15] },
  { inputPattern: ["e", "b", "a"], resultPattern: [6, 7, 15] },
  { inputPattern: ["e", "b", "b"], resultPattern: [6, 7, 15] },
  { inputPattern: ["e", "b", "c"], resultPattern: [6, 7, 15] },
  { inputPattern: ["e", "c", "a"], resultPattern: [6, 7, 15] },
  { inputPattern: ["e", "c", "b"], resultPattern: [6, 7, 15] },
  { inputPattern: ["e", "c", "c"], resultPattern: [6, 7, 15] },
  { inputPattern: ["e", "d", "a"], resultPattern: [6, 7, 15] },
  { inputPattern: ["e", "d", "b"], resultPattern: [6, 7, 15] },
  { inputPattern: ["e", "d", "c"], resultPattern: [6, 7, 15] },
  { inputPattern: ["e", "e", "a"], resultPattern: [12, 6, 7] },
  { inputPattern: ["e", "e", "b"], resultPattern: [12, 6, 7] },
  { inputPattern: ["e", "e", "c"], resultPattern: [12, 6, 7] },
  { inputPattern: ["f", "a", "a"], resultPattern: [1, 8, 6] },
  { inputPattern: ["f", "a", "b"], resultPattern: [3, 4, 8] },
  { inputPattern: ["f", "a", "c"], resultPattern: [3, 4, 10] },
  { inputPattern: ["f", "b", "a"], resultPattern: [1, 4, 6] },
  { inputPattern: ["f", "b", "b"], resultPattern: [3, 4, 6] },
  { inputPattern: ["f", "b", "c"], resultPattern: [3, 4, 11] },
  { inputPattern: ["f", "c", "a"], resultPattern: [16, 14, 8] },
  { inputPattern: ["f", "c", "b"], resultPattern: [16, 14, 8] },
  { inputPattern: ["f", "c", "c"], resultPattern: [16, 14, 8] },
  { inputPattern: ["f", "d", "a"], resultPattern: [5, 7, 6] },
  { inputPattern: ["f", "d", "b"], resultPattern: [4, 7, 9] },
  { inputPattern: ["f", "d", "c"], resultPattern: [4, 7, 9] },
  { inputPattern: ["f", "e", "a"], resultPattern: [12, 6, 5] },
  { inputPattern: ["f", "e", "b"], resultPattern: [12, 6, 5] },
  { inputPattern: ["f", "e", "c"], resultPattern: [12, 6, 5] },
  { inputPattern: ["g", "a", "a"], resultPattern: [1, 4, 8] },
  { inputPattern: ["g", "a", "b"], resultPattern: [3, 4, 8] },
  { inputPattern: ["g", "a", "c"], resultPattern: [3, 4, 10] },
  { inputPattern: ["g", "b", "a"], resultPattern: [1, 4, 13] },
  { inputPattern: ["g", "b", "b"], resultPattern: [3, 4, 13] },
  { inputPattern: ["g", "b", "c"], resultPattern: [3, 4, 11] },
  { inputPattern: ["g", "c", "a"], resultPattern: [16, 8, 5] },
  { inputPattern: ["g", "c", "b"], resultPattern: [16, 8, 1] },
  { inputPattern: ["g", "c", "c"], resultPattern: [16, 8, 1] },
  { inputPattern: ["g", "d", "a"], resultPattern: [5, 7, 6] },
  { inputPattern: ["g", "d", "b"], resultPattern: [4, 7, 9] },
  { inputPattern: ["g", "d", "c"], resultPattern: [4, 7, 9] },
  { inputPattern: ["g", "e", "a"], resultPattern: [12, 5, 7] },
  { inputPattern: ["g", "e", "b"], resultPattern: [12, 5, 7] },
  { inputPattern: ["g", "e", "c"], resultPattern: [12, 5, 7] },
  { inputPattern: ["h", "a", "a"], resultPattern: [1, 8, 6] },
  { inputPattern: ["h", "a", "b"], resultPattern: [3, 4, 8] },
  { inputPattern: ["h", "a", "c"], resultPattern: [3, 4, 10] },
  { inputPattern: ["h", "b", "a"], resultPattern: [1, 4, 6] },
  { inputPattern: ["h", "b", "b"], resultPattern: [3, 4, 6] },
  { inputPattern: ["h", "b", "c"], resultPattern: [3, 4, 11] },
  { inputPattern: ["h", "c", "a"], resultPattern: [16, 14, 8] },
  { inputPattern: ["h", "c", "b"], resultPattern: [16, 14, 8] },
  { inputPattern: ["h", "c", "c"], resultPattern: [16, 14, 8] },
  { inputPattern: ["h", "d", "a"], resultPattern: [5, 7, 6] },
  { inputPattern: ["h", "d", "b"], resultPattern: [4, 7, 9] },
  { inputPattern: ["h", "d", "c"], resultPattern: [4, 7, 9] },
  { inputPattern: ["h", "e", "a"], resultPattern: [12, 6, 5] },
  { inputPattern: ["h", "e", "b"], resultPattern: [12, 6, 5] },
  { inputPattern: ["h", "e", "c"], resultPattern: [12, 6, 5] },
];

export interface ResultContent {
  id: number;
  name: string;
  content: string;
}

export const LAND_RESULT_CONTENTS: ResultContent[] = [
  {
    id: 1,
    name: "アパート経営",
    content:
      '<p>アパート経営は、保有する土地にアパートを建築し、第三者に賃貸として貸し出すことで賃料収入を得る土地活用方法です。    賃料収入による安定した収入、相続税や固定資産税の節税対策に期待ができる土地活用方法です。    詳しくは、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/apartment/operations/221/">アパート経営について解説している記事</a>を参考にしてみてください。</p>    ',
  },
  {
    id: 2,
    name: "マンション経営",
    content:
      '<p>マンション経営は、保有する土地にマンションを建築し、入居者を集めて賃貸として貸し出すことで賃料収入を得る土地活用方法です。    賃料収入による安定した収入、相続税や固定資産税の節税対策に期待ができます。    マンション経営はアパート経営よりも規模の大きい賃貸経営を指すことが多く、その分高費用・高収益に期待ができる土地活用方法です。    詳しくは、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/mansion/management/1887/">マンション経営について解説している記事</a>を参考にしてみてください。</p>    ',
  },
  {
    id: 3,
    name: "アパート・マンション経営",
    content:
      '<p>アパート・マンション経営は、保有する土地にアパートやマンションなどの賃貸物件を建築し、第三者に賃貸として貸し出すことで賃料収入を得る土地活用方法です。    賃料収入による安定した収入、相続税や固定資産税の節税対策に期待ができます。    立地やかけられる費用によってアパートにすべきかマンションにすべきか変わってくるため、    詳しくは<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/apartment/operations/221/">アパート経営の記事</a>や    <a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/mansion/management/1887/">マンション経営の記事</a>をご覧ください。</p>    ',
  },
  {
    id: 4,
    name: "賃貸併用住宅経営",
    content:
      '<p>賃貸併用住宅経営は、自分が居住する物件と賃貸として貸し出す物件を一緒にした住宅を建築し、経営する土地活用方法です。    賃料収入による安定した収入、相続税や固定資産税の節税対策に期待ができる土地活用方法です。    また、住宅ローンを借り入れて建築することができ、賃料収入を得つつ住宅ローンを返済していくことが可能になります。    詳しく知りたい方は、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/mixed-use/rental-mixed/10882/">賃貸併用住宅について解説した記事</a>をご覧ください。</p>    ',
  },
  {
    id: 5,
    name: "戸建賃貸経営",
    content:
      '<p>戸建賃貸経営は、戸建て住宅を建築して第三者に貸し出し、賃料収入を得る土地活用方法です。    賃料収入による安定した収入、相続税や固定資産税の節税対策に期待ができます。    なお、立地によって集客難易度が変わりづらいため、アパート・マンション経営のような賃貸経営ほど立地の条件が厳しくありません。    詳しく知りたい方は、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/rental/house-rental/1926/">戸建賃貸経営について解説した記事</a>をご覧ください。</p>    ',
  },
  {
    id: 6,
    name: "駐車場経営",
    content:
      '<p>駐車場経営は、遊休地を駐車場として活用し、賃料収入を得る土地活用方法です。    月極駐車場形式とコインパーキング形式の2通りの経営方法があり、大型な設備や機器が必要ないため、初期費用を抑えつつ始められるという利点があります。    詳しく知りたい方は、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/land-use/small-investment/459/">駐車場経営について解説した記事</a>をご覧ください。</p>    ',
  },
  {
    id: 7,
    name: "トランクルーム経営",
    content:
      '<p>トランクルーム経営とは、荷物を預ける用のコンテナを建築し、そのスペースを貸し出すことで賃料収入を得る土地活用方法です。    初期費用・ランニングコストが少ない点と、立地に左右されず始めやすいという利点があります。    詳しく知りたい方は、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/land-use/small-investment/1980/">トランクルーム経営について解説した記事</a>をご覧ください。</p>    ',
  },
  {
    id: 8,
    name: "コインランドリー経営",
    content:
      '<p>コインランドリー経営とは、洗濯機や乾燥機を設置して利用料金を得る土地活用方法です。    固定客がつきやすく安定した収入を見込める点、管理の手間がかからない点が魅力として挙げられます。    詳しく知りたい方は、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/land-use/small-investment/1900/">コインランドリー経営について解説した記事</a>をご覧ください。</p>    ',
  },
  {
    id: 9,
    name: "高齢者施設経営",
    content:
      '<p>ある程度広い土地を持っている場合は、老人ホームやサ高住のような高齢者向け施設を建築し、経営するという方法もあります。    経営スタイルはさまざまで、事業者に一括借り上げで貸し出す方法やテナントとして募集する方法など、かけられる自己資金や借入額と相談しつつ決めるようにしましょう。    詳しく知りたい方は、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/land-use/welfare-medical/1909/">老人ホーム経営に関して解説した記事</a>や    <a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/land-use/welfare-medical/1905/">サ高住に関して解説した記事</a>をご覧ください。</p>    ',
  },
  {
    id: 10,
    name: "商業施設など大規模施設経営",
    content:
      '<p>立地の良い土地やある程度広い土地の場合は、商業施設などの大規模施設を経営するという土地活用方法もあります。    レストランやドラッグストア、ショッピングセンターなど、土地の広さや地域の需要に合わせて柔軟に活用方法を選ぶことが可能です。    詳しく知りたい方は、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/land-use/commercial/39917/">商業施設に関して解説した記事</a>をご覧ください。</p>    ',
  },
  {
    id: 11,
    name: "ビル経営",
    content:
      '<p>ビル経営とは、オフィスビルや商業ビルを建築してテナントとして貸し出し、賃料収入を得る土地活用方法です。    立地によってどんなビルを建築するかは変わってきますが、集客さえうまくいけば高収益が期待できる土地活用方法です。    詳しく知りたい方は、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/land-use/commercial/15549/">ビル経営に関して解説した記事</a>をご覧ください。</p>    ',
  },
  {
    id: 12,
    name: "太陽光発電用地として活用",
    content:
      '<p>太陽光発電としての活用とは、太陽光パネルを土地に設置し、生み出した電力を電力会社に売却することで収益を得る土地の活用方法です。    安定した収益に期待ができ、また維持・管理のための手間もそれほどかからないのが特徴です。    詳しく知りたい方は、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/land-use/small-investment/15325/">太陽光発電経営に関して解説した記事</a>をご覧ください。</p>    ',
  },
  {
    id: 13,
    name: "等価交換",
    content:
      '<p>等価交換とは、土地を建築会社に譲渡・売却してその土地の上に建物を建ててもらい、その代わりに土地の価値の割合に応じて建物の所有権を得る土地活用の方法です。    この方法だと土地を一部失うことにはなりますが、費用をかけずにマンション・アパート経営を始めることが可能になります。    詳しく知りたい方は、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/land-use/basic-knowledge/10890/">等価交換に関して解説した記事</a>をご覧ください。</p>    ',
  },
  {
    id: 14,
    name: "土地を貸す",
    content:
      '<p>土地を使う予定がない方は、土地を貸して賃料収入を得るという方法もあります。    安定した賃料収入を得られると同時に、土地の手間や管理も行う必要がありません。    そのため「土地を持っているけれど使う予定がない」という方におすすめの土地活用方法です。    詳しく知りたい方は、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/rental/land-rental/213/">土地の賃貸に関して解説した記事</a>をご覧ください。</p>    ',
  },
  {
    id: 15,
    name: "定期借地権として課す",
    content:
      '<p>定期借地権とは、期間を定めて土地を貸す権利のことを言います。    契約期間や利用目的によって一般定期借地権、建物譲渡特約付借地権、事業用借地権の3つの権利に分かれます。    通常の借地権とは異なり、契約期間が切れた際に土地を変換してもらいやすく、期限が明確に決まっている中で土地活用をしたい方におすすめの方法です。    詳しく知りたい方は、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/rental/land-rental/1943/">定期借地権に関して解説した記事</a>をご覧ください。</p>    ',
  },
  {
    id: 16,
    name: "ロードサイド店舗経営",
    content:
      '<p>大通りや車通りの多い道路沿いに土地を持っている場合は、ファミリーレストランやアパレルショップなどの店舗を経営するという方法もあります。    事業用定期借地方式とリースバック方式の2つの方法があり、経営したい店舗形態やかけられる予算によってどちらの方法が良いかは変わってきます。    詳しく知りたい方は、<a target="_blank" rel="noopener noreferrer" href="https://land.ieul.jp/knowledge/land-use/commercial/32975/">ロードサイド店舗経営に関して解説した記事</a>をご覧ください。</p>    ',
  },
];
